module.exports = __webpack_public_path__ + "static/media/cross-circular.ddf4fb8c.png";